<section>
   <ng-container class="register-profesori">
      <div class="links">

         <a routerLink="form-register" routerLinkActive="active">{{ 'new_entries.manual_user_registration' | translate
            }}</a>

         <a routerLink="bulk-register" routerLinkActive="active">{{ 'new_entries.bulk_user_registration' | translate
            }}</a>

      </div>

   </ng-container>
</section>

<div class="shadowBorder">
   <router-outlet></router-outlet>
</div>